import React, { useRef } from 'react';
import { usePage } from '@inertiajs/react';
import SearchIcon from '@/User/Assets/Svgs/SearchPrimaryIcon.svg';
import JobOfferCard from '@/User/Components/JobOffer/JobOfferCard';
import ChevronRightBlueIcon from '@/User/Assets/Svgs/ChevronRightBlueIcon.svg';
import { CAROUSEL_CARD, CAROUSEL_WRAPPER } from '@/User/Constants/elements';
import { useCarousel } from '@/User/Components/useCarousel';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const NewSearch = () => {
    const { jobOfferList } = usePage().props;
    const classSlideItem = `
        min-w-55 w-55
    `;

    const carouselRef = useRef(null);
    const { handleNextSlide, isHaveButton } = useCarousel(carouselRef);

    return jobOfferList?.data.length > 0 && (
        <section id="new-search" className="py-6 my-6 md:my-0 lg:py-10 border-y border-pattens-blue container bg-white">
            <div className="text-center text-primary mb-5">
                <div className="flex justify-center items-center mb-2.5">
                    <LazyLoadImage src={SearchIcon} alt="新着案件から探す" className='size-6' />
                </div>
                <h3 className="leading-tight text-2xl">新着案件から探す</h3>
            </div>

            <div className="flex">
                <div ref={carouselRef} className="mx-0 lg:mx-4 overflow-x-auto pb-4">
                    <div id={CAROUSEL_WRAPPER} className="flex gap-4">
                        {jobOfferList.data.map((jobOffer) => (
                            <div id={CAROUSEL_CARD} className={`${classSlideItem}`} key={`job-${jobOffer.id}`}>
                                <JobOfferCard jobOffer={jobOffer} isNew={true} classImgItem="w-204px" />
                            </div>
                        ))}
                    </div>
                </div>
                {isHaveButton && (
                    <div className="content-center">
                        <div className="hidden lg:block bg-alice-blue-3 h-40 w-6">
                            <img
                                className="w-full h-full cursor-pointer"
                                src={ChevronRightBlueIcon}
                                alt="Chevron Right Icon"
                                onClick={handleNextSlide}
                            />
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default NewSearch;
